import { inject } from '@angular/core';
import { ISubscriptionTicket, SUBSCRIPTION_TICKETS } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { IListGateway } from '../gateways';

export class SubscriptionGateway implements IListGateway<
  number,
  IApiResponse<ISubscriptionTicket[]>
> {
  private readonly listRestCallBuilder: RestCallBuilder<ISubscriptionTicket[]> =
    new RestCallBuilder<ISubscriptionTicket[]>([]);
  private readonly configService: AppConfigService = inject(AppConfigService);

  list(serviceAreaId: number): Observable<IApiResponse<ISubscriptionTicket[]>> {
    return this.listRestCallBuilder
      .getExternal(
        this.configService.get().general.webshopApiUrl + '/api/subscriptions/all',
        {
          serviceAreaId: serviceAreaId,
        }
      )
      .validate(API_RESPONSE_SCHEMA(SUBSCRIPTION_TICKETS), 'Subscription.list')
      .handleMessages(undefined, true)
      .build();
  }
}
